import { useEffect } from 'react';
import { CountryWidget } from 'widgets/settings/CountryWidget';
import { useAppDispatch } from 'app/store';
import { setActionBtnTitle, setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';

export const CountriesPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Страны'));

    dispatch(setActionBtnTitle('Добавить'));
    dispatch(setHeaderAction('edit'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <CountryWidget />;
};
